import { baseConfig } from "./environment.base";
// Environment config for the development environment
baseConfig.production = true;
baseConfig.staging = true;
baseConfig.rollbar.enabled = true;
export const environment = baseConfig;
